import { formatCurrencyToApi } from "./formatCurrencyToApi";

export function resolveOpenValueAmount(openValue: boolean, value: string) {
  return openValue ? null : formatCurrencyToApi(value);
}

export function resolveCreditCardTypeForOrder(
  openValue: boolean,
  hasTagMix: boolean,
  creditCardType: string
) {
  if (openValue) return "EARLY_SELLER";
  return hasTagMix ? "EARLY_MIXED" : creditCardType;
}

export function resolveCreditCardInstallmentMethod(
  openValue: boolean,
  hasTagMix: boolean,
  creditCardType: string
) {
  if (openValue) return "CREDIT_CARD_EARLY_SELLER";
  if (hasTagMix) return "CREDIT_CARD_EARLY_MIXED";
  return creditCardType === "RECURRENT" ? "CREDIT_CARD" : `CREDIT_CARD_${creditCardType}`;
}
